export const ActionTypes = {
  SET_DASHBOARD_LAYOUT: 'SET_DASHBOARD_LAYOUT',
  CHANGE_DASHBOARD_LIBRARY_LAYOUT: 'CHANGE_DASHBOARD_LIBRARY_LAYOUT',
  CHANGE_DASHBOARD_LIBRARY_FILTERS: 'CHANGE_DASHBOARD_LIBRARY_FILTERS',
  SET_DASHBOARD_LIBRARY_FILTERS: 'SET_DASHBOARD_LIBRARY_FILTERS',
  RESET_DASHBOARD_LIBRARY_FILTERS: 'RESET_DASHBOARD_LIBRARY_FILTERS',
  GET_DASHBOARD_OPTIONS_FOR_USER: 'GET_DASHBOARD_OPTIONS_FOR_USER',
  SET_SHORTCUT_AND_HOTKEYS_OPTIONS: 'SET_SHORTCUT_AND_HOTKEYS_OPTIONS',
  SET_ROTATION: 'SET_ROTATION',
  GET_THEME: 'GET_THEME',
  SET_THEME: 'SET_THEME',
  SET_THEME_SERVICE_TRIGGER: 'SET_THEME_SERVICE_TRIGGER',
  HANDLE_ORGANIZATION_CHANGE: 'HANDLE_ORGANIZATION_CHANGE',
  SET_IS_MOBILE_DEVICE: 'SET_IS_MOBILE_DEVICE',
  SET_OPEN_SOLUTIONS_IN_NEW_TAB: 'SET_OPEN_SOLUTIONS_IN_NEW_TAB',
};

export function changeDashboardLibraryLayout(dispatch, layout) {
  dispatch({
    type: ActionTypes.CHANGE_DASHBOARD_LIBRARY_LAYOUT,
    layout,
  });
}

export function changeDashboardLibraryFilters(dispatch, queryParams, showDashboardsFilter) {
  dispatch({
    type: ActionTypes.CHANGE_DASHBOARD_LIBRARY_FILTERS,
    queryParams,
    showDashboardsFilter,
  });
}

export function setDashboardLibraryFilters(dispatch, filtersData) {
  dispatch({
    type: ActionTypes.SET_DASHBOARD_LIBRARY_FILTERS,
    filtersData,
  });
}

export function resetDashboardLibraryFilters(dispatch) {
  dispatch({
    type: ActionTypes.RESET_DASHBOARD_LIBRARY_FILTERS,
  });
}

export function getDashboardOptionsForUser(dispatch) {
  dispatch({
    type: ActionTypes.GET_DASHBOARD_OPTIONS_FOR_USER,
  });
}

export function getTheme(dispatch) {
  dispatch({
    type: ActionTypes.GET_THEME,
  });
}

export function setTheme(dispatch, isLightThemeActive) {
  dispatch({
    type: ActionTypes.SET_THEME_SERVICE_TRIGGER,
    isLightThemeActive,
  });
}

export function setIsMobileDevice(dispatch, isMobileDevice) {
  dispatch({
    type: ActionTypes.SET_IS_MOBILE_DEVICE,
    isMobileDevice,
  });
}
